import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Text, List, ListItem } from '@paygreen/paygreen-ui';

const ContributorsList = ({ t }) => {
    const typeOfContributors = ['partners', 'customers', 'you'];

    return (
        <List listStyle="icon">
            {typeOfContributors.map((element, index) => (
                <ListItem bulletSize="xs" key={index}>
                    <Text textSize="xs" colorWab="grey50">
                        <Trans
                            i18nKey={`contributions.globalView.explanationModal.whoContributes.${element}.text`}
                        >
                            ...
                            <Text
                                htmlTag="strong"
                                textSize="xs"
                                colorWab="grey50"
                            >
                                {{
                                    id: t(
                                        `contributions.globalView.explanationModal.whoContributes.${element}.id`,
                                    ),
                                }}
                            </Text>
                            ...
                        </Trans>
                    </Text>
                </ListItem>
            ))}
        </List>
    );
};

export default withTranslation('common')(ContributorsList);
